import { Box, HStack, Text } from "@chakra-ui/react";
import { useProjectSettings } from "@/hooks/useProjectSettings";
import { useMe } from "@/hooks/useAuth";

export default function DryRunBanner() {
  const { data: me } = useMe();
  // Banner is project-scoped now — only fetch + show once the operator
  // has picked a project. No active project → no per-project settings →
  // nothing to warn about (and the API call would 412 anyway).
  const { data: settings } = useProjectSettings({ enabled: !!me?.lastActiveProjectId });
  if (!settings?.dryRunEnabled) return null;

  return (
    <Box bg="orange.500" color="white" px={4} py={2}>
      <HStack
        justify="center"
        fontSize="sm"
        gap={4}
        wrap="wrap"
        textAlign="center"
      >
        <Text>
          <b>Dry-run mode</b> —{" "}
          {settings.dryRunPhoneNumber ? (
            <>
              calls go to <code>{settings.dryRunPhoneNumber}</code>
            </>
          ) : (
            <>calls are blocked (set a test number in Settings → App)</>
          )}
          {settings.dryRunEmail ? (
            <>
              {" "}
              · invitations + emails to <code>{settings.dryRunEmail}</code>
            </>
          ) : (
            <> · invites + emails are suppressed</>
          )}
          . Real clients are not contacted.
        </Text>
      </HStack>
    </Box>
  );
}
